/* eslint-disable */
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import { Box, Chip, Dialog, DialogContent, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Button, Col, Form, Row, Select } from 'antd';
import InputLabel from 'components/InputLabel/index';
import CustomDateInput from 'components/inputs/CustomDateInput';
import CustomTextInput from 'components/inputs/CustomTextInput';
import CustomSelectInput from 'components/inputs/CustomSelectInput';
import ViewEditModalHeader from 'components/modal/ViewEditModalHeader';
import { toastConfig } from 'config';
import moment from 'moment';
import ConfirmModal from 'components/modal/ConfirmModal';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import FileUpload from 'components/inputs/FileUpload';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';
import CardAccordion from 'components/CardAccordion/CardAccordion';
import CustomTextareaInput from 'components/inputs/CustomTextareInput';
import useGetStateFromParams from 'static-solutions/hook/useGetStateFromParams';

const rootCaseOptions = [
	{
		id: 1,
		value: 'Non-compliance',
		label: 'Non-compliance',
	},
	{
		id: 2,
		value: 'Human error',
		label: 'Human error',
	},
	{
		id: 3,
		value: '⁠Non-performance',
		label: '⁠Non-performance',
	},
];

const impactOptions = [
	{
		id: 1,
		value: 'Reporting inaccuracy',
		label: 'Reporting inaccuracy',
	},
	{
		id: 2,
		value: 'Financial loss',
		label: 'Financial loss',
	},
	{
		id: 3,
		value: '⁠Potential fine by regulators',
		label: '⁠Potential fine by regulators',
	},
];

const controlTestingRating = [
	{
		id: 1,
		value: 'Effective',
		label: 'Effective',
		color: 'green',
	},
	{
		id: 2,
		value: 'Major Improvement Required',
		label: 'Major Improvement Required',
		color: 'orange',
	},
	{
		id: 2,
		value: 'Same Improvement Required',
		label: 'Same Improvement Required',
		color: 'yellow',
	},
	{
		id: 2,
		value: 'Unacceptable',
		label: 'Unacceptable',
		color: 'red',
	},
];

function DetailsModal({ item: id, setItem, data, showModal, handleClose, setRerender }) {
	const [form] = Form.useForm();

	const [sendControlData, { isLoading, isSuccess, isError }] = useSendControlDataMutation();

	const theme = useTheme();
	// const { state } = useLocation();
	const { state } = useGetStateFromParams();
	const userId = useSelector((state) => state.profile.profileData.userId);
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);
	const [question, setQuestion] = useState(null);
	const [payload, setPayload] = useState(null);
	const [confirmModal, setConfirmModal] = useState(false);
	const [pagination, setPagination] = useState({
		currentPage: 0,
		firstPage: 0,
		lastPage: 0,
	});
	const [screenSize, setScreenSize] = useState('md');

	const handleSubmit = (submittedData) => {
		const refinedSubmittedData = {
			id: submittedData.id,
			actionType: 'submit',

			rootCause: submittedData.rootCause ?? '',
			impact: submittedData.impact ?? '',
			finding: submittedData.finding ?? '',
			// impactDetails: submittedData.impactDetails ?? '',
			recommendation: submittedData.recommendation ?? '',
			ownerFeedback: submittedData.ownerFeedback ?? '',
			agreedResolutionTime: submittedData.agreedResolutionTime ?? '',
			rating: submittedData.rating ?? '',
			evidenceAttachment: submittedData.evidenceAttachment ?? '',
			testingEvidence: submittedData.testingEvidence ?? '',
			samplingMethod: submittedData.samplingMethod ?? '',
			sampleSize: submittedData.sampleSize ?? '',
			populationSize: submittedData.populationSize ?? '',
		};

		// console.log(refinedSubmittedData);

		const convertJson = JSON.stringify(refinedSubmittedData);
		const convertBase64 = btoa(convertJson);

		setPayload({
			data: convertBase64,
			processCode: state?.processCode,
			scriptName: 'submitTesting',
		});

		setConfirmModal(true);
	};

	const handleAction = (action) => {
		const refinedSubmittedData = {
			id,
			action,
		};
		const convertJson = JSON.stringify(refinedSubmittedData);
		const convertBase64 = btoa(convertJson);
		// console.log('🚀 ~ handleAction ~ convertBase64:', convertBase64);

		setPayload({
			data: convertBase64,
			processCode: state?.processCode,
			scriptName: 'submitAnswer',
		});
		setConfirmModal(true);
	};

	const currentUserIdentity = (id, data) => {
		// const currentItem = data.find((item) => item.id === id);
		// console.log('question-----', question);
		if (
			question?.testerUserId === userId &&
			(question.testingStatus.toLowerCase() === 'testing pending' || question.testingStatus.toLowerCase() === 'testing rejected')
		) {
			return 'AccessToSubmit';
		} else return 'AccessToView';
	};

	const onModalOkHandler = () => {
		if (payload) {
			sendControlData(payload);
		}
	};

	// const actualChangeHandler = (e) => {
	// 	const expectation = question?.expectation.toLowerCase();
	// 	const remark = e.target.value.toLowerCase();

	// 	setActualValue(e.target.value?.toLowerCase());

	// 	if (remark?.length < 1) return;
	// 	else if (expectation === remark) setRemarkVisible(false);
	// 	else setRemarkVisible(true);
	// };

	const onPreHandler = () => {
		if (pagination.currentPage > 0) {
			const prevPageIndex = pagination.currentPage - 1;
			if (prevPageIndex > -1 && pagination.lastPage) {
				setQuestion(data[prevPageIndex]);
				setItem(data[prevPageIndex].id);
			} else setQuestion(null);

			setPagination((prev) => ({
				...prev,
				currentPage: prevPageIndex,
			}));
		}
	};

	const onNextHandler = () => {
		if (pagination.currentPage < pagination.lastPage) {
			const nextPageIndex = pagination.currentPage + 1;
			if (nextPageIndex > -1 && pagination.lastPage) {
				setQuestion(data[nextPageIndex]);
				setItem(data[nextPageIndex].id);
			} else setQuestion(null);

			setPagination((prev) => ({
				...prev,
				currentPage: nextPageIndex,
			}));
		}
	};

	useEffect(() => {
		if (isSuccess) {
			toast.success('Success! Action completed ', toastConfig);
			// form.resetFields();
			setRerender((prev) => prev + 1);
			handleClose();
			setPayload(null);
		} else if (isError) {
			toast.error('Failed! Action not completed', toastConfig);
			// form.resetFields();
			setPayload(null);
		}
	}, [isSuccess, isError]);

	useEffect(() => {
		// console.log('------------', data);

		if (data?.length > 0 && id) {
			const currentItemIndex = data?.findIndex((item) => item.id === id);
			if (currentItemIndex > -1) setQuestion(data[currentItemIndex]);
			setPagination({
				currentPage: currentItemIndex,
				firstPage: 0,
				lastPage: data?.length - 1,
			});
		}
	}, []);

	return (
		<>
			<Dialog
				fullWidth={true}
				open={showModal}
				aria-labelledby="announcement-modal"
				sx={{ '.MuiPaper-root': { borderRadius: '8px' } }}
				fullScreen={screenSize === 'full' ? true : false}
				maxWidth={screenSize}
			>
				<ViewEditModalHeader
					icon={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />}
					viewType={false}
					screenSize={screenSize}
					handleClose={handleClose}
					setScreenSize={setScreenSize}
					headerTitle={'View Control Testing'}
				/>

				<DialogContent>
					{question === null ? (
						<Box>Loading...</Box>
					) : (
						<Form form={form} layout="vertical" requiredMark={false} validateTrigger={['onChange', 'onBlur']} onFinish={handleSubmit}>
							<Form.Item noStyle name="id" initialValue={question?.id} />
							<CardAccordion
								title="Control Details (Common for Both Assurance & Testing)"
								darkTitle={true}
								sx={{
									mb: 2,
								}}
								customHeaderSX={{
									backgroundColor: '#e1f0fb !important',
									p: '10px',
									fontSize: '16px !important',
								}}
								typographySX={{ fontSize: '16px !important' }}
							>
								<Row gutter={[16, 0]}>
									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Control Questionnaire" head={true} />
									</Col>
									<Col xs={24} md={18} lg={18} xl={20}>
										<Chip
											label={question?.controlQuestion}
											variant="outlined"
											sx={{
												width: '100%',
												justifyContent: 'start',
												fontWeight: 600,
												background: '#f2f2f2',
												borderColor: '#e2ebf7',
											}}
										/>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Control Domain" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput form={form} disabled={true} name="controlDomain" value={question?.controlDomain} />
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Control Sub-Domain" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput form={form} disabled={true} name="controlSubDomain" value={question?.controlSubDomain} />
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Control ID" head={true} sx={{ marginBottom: 0 }} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput
											form={form}
											disabled={true}
											name="controlId"
											value={question?.controlId}
											style={{ marginBottom: 0 }}
										/>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Control Category" head={true} sx={{ marginBottom: 0 }} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput
											form={form}
											disabled={true}
											name="controlCategory"
											style={{ marginBottom: 0 }}
											value={question?.controlCategory}
										/>
									</Col>
								</Row>
							</CardAccordion>

							<CardAccordion
								title="Assurance (Provided by Control Assurer & Owner)"
								darkTitle={true}
								sx={{
									mb: 2,
								}}
								customHeaderSX={{
									backgroundColor: '#e1f0fb !important',
									p: '10px',
									fontSize: '16px !important',
								}}
								typographySX={{ fontSize: '16px !important' }}
							>
								<Row gutter={[16, 0]}>
									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Control Assurer" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput value={question?.assurerName} disabled={true} form={form} name="assurerName" />
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Control Owner" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput value={question?.ownerName} disabled={true} form={form} name="ownerName" />
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Assurance Frequency" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput
											form={form}
											disabled={true}
											name="reportingFrequency"
											value={question?.reportingFrequency}
											style={{ textTransform: 'capitalize' }}
										/>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Assurance Period" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput
											form={form}
											disabled={true}
											name="assurancePeriod"
											value={question?.assurancePeriod}
											style={{ textTransform: 'capitalize' }}
										/>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Assurance Due Date" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput
											form={form}
											disabled={true}
											name="assuranceDueDate"
											value={question?.assuranceDueDate ? moment(question?.assuranceDueDate)?.format('DD MMMM, YYYY') : ''}
										/>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Assurance Date" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput
											form={form}
											disabled={true}
											name="assuranceDate"
											style={{
												fontWeight: 500,
												color: moment(question?.answerDueDate).isAfter(moment(question?.assuranceDueDate))
													? '#000D1A'
													: '#bb2222',
											}}
											value={question?.assuranceDate ? moment(question?.assuranceDate)?.format('DD MMMM, YYYY') : ''}
										/>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Assurance Expectation" head={true} sx={{ marginBottom: 0 }} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput
											form={form}
											disabled={true}
											name="assuranceExpectation"
											value={question?.assuranceExpectation}
											style={{
												marginBottom: 0,
												textTransform: 'capitalize',
											}}
										/>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Actual Assurance" head={true} sx={{ marginBottom: 0 }} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput
											form={form}
											disabled={true}
											name="assuranceActual"
											value={question?.assuranceActual}
											style={{
												fontWeight: 500,
												marginBottom: 0,
												textTransform: 'capitalize',
												color: question?.assuranceExpectation !== question?.assuranceActual ? '#bb2222' : '#30653d',
												backgroundColor: question?.assuranceExpectation !== question?.assuranceActual ? '#ffe2e2' : '#dbf7e2',
											}}
										/>
									</Col>
								</Row>
							</CardAccordion>

							<CardAccordion
								title="Control Testing (Conducted by Independent Tester)"
								darkTitle={true}
								sx={{
									mb: 2,
								}}
								customHeaderSX={{
									backgroundColor: '#e1f0fb !important',
									p: '10px',
									fontSize: '16px !important',
								}}
								typographySX={{ fontSize: '16px !important' }}
							>
								<Row gutter={[16, 0]}>
									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Control Tester" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput value={question?.testerName} disabled={true} form={form} name="testerName" />
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Testing Frequency" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput value={question?.testingFrequency} disabled={true} form={form} name="testingFrequency" />
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Reporting Period" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput value={question?.reportingPeriod} disabled={true} form={form} name="reportingPeriod" />
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Reporting Due Date" head={true} sx={{ marginBottom: 0 }} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput
											form={form}
											disabled={true}
											name="testingDueDate"
											style={{ marginBottom: 0 }}
											value={question?.testingDueDate ? moment(question?.testingDueDate)?.format('DD MMMM, YYYY') : ''}
										/>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Reporting Date" head={true} sx={{ marginBottom: 0 }} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput
											form={form}
											disabled={true}
											name="testingDate"
											style={{
												marginBottom: 0,
												fontWeight: 500,
												color: moment(question?.testingDate).isAfter(moment(question?.testingDueDate))
													? '#000D1A'
													: '#bb2222',
											}}
											value={question?.testingDueDate ? moment(question?.testingDate)?.format('DD MMMM, YYYY') : ''}
										/>
									</Col>
								</Row>
							</CardAccordion>

							<CardAccordion
								title="Testing Execution Details"
								darkTitle={true}
								sx={{
									mb: 2,
								}}
								customHeaderSX={{
									backgroundColor: '#e1f0fb !important',
									p: '10px',
									fontSize: '16px !important',
								}}
								typographySX={{ fontSize: '16px !important' }}
							>
								<Row gutter={[16, 0]}>
									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Data Population Size" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput
											form={form}
											name="populationSize"
											value={question?.populationSize}
											disabled={currentUserIdentity(id, data) === 'AccessToView'}
											rules={[
												{
													required: true,
													message: 'Field is required',
												},
											]}
										/>
									</Col>

									{/* <Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Sampling Method" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput
											form={form}
											name="samplingMethod"
											value={question?.samplingMethod}
											disabled={currentUserIdentity(id, data) === 'AccessToView'}
											rules={[
												{
													required: true,
													message: 'Field is required',
												},
											]}
										/>
									</Col> */}

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Sample Size" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput
											form={form}
											name="sampleSize"
											value={question?.sampleSize}
											disabled={currentUserIdentity(id, data) === 'AccessToView'}
											rules={[
												{
													required: true,
													message: 'Field is required',
												},
											]}
										/>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Testing Evidence" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomTextInput
											form={form}
											name="testingEvidence"
											value={question?.testingEvidence}
											disabled={currentUserIdentity(id, data) === 'AccessToView'}
										/>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Testing Evidence Attachment" head={true} sx={{ marginBottom: 0 }} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<Box
											sx={{
												'& .ant-form-item': { marginBottom: 0 },
												'& .ant-upload-select': {
													display: 'block',
													width: '100% !important',
												},
											}}
										>
											<FileUpload
												name="evidenceAttachment"
												processCode={state?.processCode}
												existingFieldList={question?.evidenceAttachment}
												disabled={currentUserIdentity(id, data) === 'AccessToView'}
											/>
										</Box>
									</Col>
								</Row>
							</CardAccordion>

							<CardAccordion
								title="Findings & Resolution"
								darkTitle={true}
								sx={{
									mb: 2,
								}}
								customHeaderSX={{
									backgroundColor: '#e1f0fb !important',
									p: '10px',
									fontSize: '16px !important',
								}}
								typographySX={{ fontSize: '16px !important' }}
							>
								<Row gutter={[16, 0]}>
									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Finding" head={true} />
									</Col>
									<Col xs={24} md={18} xl={20}>
										<CustomTextareaInput
											form={form}
											name="finding"
											value={question?.finding ?? ''}
											disabled={currentUserIdentity(id, data) === 'AccessToView'}
										/>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Impact" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomSelectInput
											form={form}
											name="impact"
											value={question?.impact}
											disabled={currentUserIdentity(id, data) === 'AccessToView'}
										>
											{impactOptions?.map((item, index) => (
												<Select.Option key={index} value={item?.value}>
													{item?.label}
												</Select.Option>
											))}
										</CustomSelectInput>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Root Cause" head={true} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomSelectInput
											form={form}
											name="rootCause"
											value={question?.rootCause}
											disabled={currentUserIdentity(id, data) === 'AccessToView'}
										>
											{rootCaseOptions?.map((item, index) => (
												<Select.Option key={index} value={item?.value}>
													{item?.label}
												</Select.Option>
											))}
										</CustomSelectInput>
									</Col>

									{/* <Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Impact Details" head={true} />
									</Col>
									<Col xs={24} md={18} xl={20}>
										<CustomTextInput
											form={form}
											name="impactDetails"
											value={question?.impactDetails}
											disabled={currentUserIdentity(id, data) === 'AccessToView'}
										/>
									</Col> */}

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Recommendation" head={true} style={{ marginBottom: 0 }} />
									</Col>
									<Col xs={24} md={18} xl={20}>
										<CustomTextareaInput
											form={form}
											name="recommendation"
											value={question?.recommendation}
											disabled={currentUserIdentity(id, data) === 'AccessToView'}
										/>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Owner's Feedback" head={true} />
									</Col>
									<Col xs={24} md={18} xl={20}>
										<CustomTextareaInput
											form={form}
											name="ownerFeedback"
											value={question?.ownerFeedback}
											disabled={currentUserIdentity(id, data) === 'AccessToView'}
										/>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Control Rating" head={true} sx={{ marginBottom: 0 }} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomSelectInput
											form={form}
											name="rating"
											value={question?.rating}
											style={{
												marginBottom: 0,
												fontWeight: 500,
												color: controlTestingRating?.find((item) => item?.value === question?.rating)?.color,
											}}
											disabled={currentUserIdentity(id, data) === 'AccessToView'}
										>
											{controlTestingRating?.map((item, index) => (
												<Select.Option key={index} value={item?.value}>
													{item?.label}
												</Select.Option>
											))}
										</CustomSelectInput>
									</Col>

									<Col xs={24} md={6} lg={6} xl={4}>
										<InputLabel label="Resolution Timeline" head={true} sx={{ marginBottom: 0 }} />
									</Col>
									<Col xs={24} md={18} lg={6} xl={8}>
										<CustomDateInput
											form={form}
											name="agreedResolutionTime"
											style={{ marginBottom: 0 }}
											value={question?.agreedResolutionTime}
											disabled={currentUserIdentity(id, data) === 'AccessToView'}
										/>
									</Col>
								</Row>
							</CardAccordion>

							<Row>
								<Col xs={24}>
									<Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 2 }}>
										<Box>
											<>
												{/* {currentUserIdentity(id, data) === 'LoginAsOwner' && (
													<>
														<MuiButton
															type="button"
															htmlType="submit"
															disabled={false}
															variant="contained"
															sx={{
																fontSize: '13px',
																fontWeight: '500',
																borderRadius: '6px',
																marginLeft: '6px',
																padding: '4px 0',
																bgcolor: 'rgb(3, 57, 108)',
																color: 'common.white',
																width: '6rem',
																'&:hover': { bgcolor: 'rgb(3, 57, 108)' },
															}}
															onClick={() => handleAction('approve')}
														>
															Approve
														</MuiButton>
														<MuiButton
															type="button"
															// htmlType="submit"
															disabled={false}
															variant="contained"
															sx={{
																fontSize: '13px',
																fontWeight: '500',
																borderRadius: '6px',
																marginLeft: '6px',
																padding: '4px 0',
																bgcolor: theme.palette.lynTheme.delete,
																color: 'common.white',
																width: '7rem',
																'&:hover': { bgcolor: theme.palette.lynTheme.delete },
															}}
															onClick={() => handleAction('reject')}
														>
															Reject
														</MuiButton>
													</>
												)} */}

												{currentUserIdentity(id, data) === 'AccessToSubmit' && (
													<Button type="primary" htmlType="submit" disabled={isLoading}>
														Submit
													</Button>
												)}
											</>
										</Box>

										<Stack direction="row" justifyContent="right" sx={{ mb: 2, gap: '5px' }}>
											<Button onClick={onPreHandler} disabled={pagination?.currentPage < 1}>
												<CaretLeftOutlined />
											</Button>

											<Button onClick={onNextHandler} disabled={pagination?.currentPage >= pagination?.lastPage}>
												<CaretRightOutlined />
											</Button>
										</Stack>
									</Stack>
								</Col>
							</Row>
						</Form>
					)}
				</DialogContent>
			</Dialog>

			{confirmModal && (
				<ConfirmModal
					icon={false}
					modalData={{ head: 'Confirmation' }}
					showModal={confirmModal}
					setShowModal={setConfirmModal}
					handleSubmit={onModalOkHandler}
				/>
			)}
		</>
	);
}

export default DetailsModal;
